import DashboardContent from 'components/lab/atoms/DashboardContent'
import { BillingChargesListing } from 'components/lab/billingCharge/BillingChargesListing'
import routes from 'components/lab/constants/routes'
import React from 'react'
import { useLocation } from 'react-router-dom'

type BillingChargesListingPageProps = {
  paperClaims?: boolean
}

export const BillingChargesListingPage = ({ paperClaims = false }: BillingChargesListingPageProps) => {
  const location = useLocation()
  const chargeBucket = React.useMemo(() => {
    const bucket = new URLSearchParams(location.search).get('bucket')

    switch (bucket) {
      case routes.order.billing.billingChargesAll.bucket:
        return 'all'
      case routes.order.billing.billingChargesSubmitted.bucket:
        return 'submitted'
      case routes.order.billing.billingChargesFailedSubmission.bucket:
        return 'failed'
      case routes.order.billing.billingChargesActive.bucket:
        return 'active'
      case routes.order.billing.billingChargesPaid.bucket:
        return 'paid'
      case routes.order.billing.billingChargesCobPending.bucket:
        return 'cob'
      case routes.order.billing.billingChargesCrossedOver.bucket:
        return 'crossedOver'
      case routes.order.billing.billingChargesRejected.bucket:
        return 'rejected'
      case routes.order.billing.billingChargesPendingSubmission.bucket:
      default:
        return 'pending'
    }
  }, [location.search])

  return (
    <div>
      <DashboardContent
        title={paperClaims ? 'Paper Claims' : 'Charges'}
        icon="fa fa-hdd"
        content={
          <div>
            <div className="card card-primary mt-1 p-2">
              <BillingChargesListing
                allowSubmissions
                claimSubmissionMethod={paperClaims ? 'PAPER' : undefined}
                bucket={chargeBucket}
              />
            </div>
          </div>
        }
        breadcrumb={[
          {
            label: 'Billing Charges',
            to: `${routes.index}${routes.device.root}`,
          },
        ]}
      />
    </div>
  )
}
